import React from 'react';
import { KibPetCard } from '@chewy/kib-cards-react';
import { PetInterface } from 'types/pet';
import { useHistory } from 'react-router-dom';
import { Analytics } from 'global';
import './pet-cards.scss';
import '@chewy/kib-layout-styles/dist/styles/kib-grid.css';
import { KibGrid, KibGridItem } from '@chewy/kib-layout-react';
import { getPetProfilePath } from '../../util/config';
import { conditionalHistoryPush } from '../../util/helpers';

export default function PetCards({
  petProfiles,
  analytics,
}: {
  petProfiles: PetInterface[];
  analytics: Analytics;
}) {
  const history = useHistory();

  const getBanner = (photoUrl?: String): String =>
    !photoUrl ? '' : photoUrl.replace(/SS150/, '360');
  const handleClick = (petProfileId: number) => {
    analytics.trackEvent('account-overview', 'click', 'pet-profile');
    conditionalHistoryPush(getPetProfilePath(petProfileId), history);
  };
  return (
    <div className="pet-cards">
      <KibGrid>
        {petProfiles.map((pet, index) => (
          <KibGridItem key={index} className="pet-cards__card-container" span="4@sm 4@min-md">
            <KibPetCard
              key={pet.id}
              cover={getBanner(pet.photoUrl)}
              avatar={pet.avatarUrl}
              caption={pet.name}
              onClick={() => handleClick(pet.id)}
              data-testid={`pet-card-pet-${index + 1}`}
            />
          </KibGridItem>
        ))}
      </KibGrid>
    </div>
  );
}
